import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ENV } from "../../config/config";
import { useGetRoleQuery } from "../../redux/api";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import validator from "validator";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import AwardForm from "./AwardForm";
import { useGetAboutQuery, useEditAboutMutation } from "../../redux/api";

const About = () => {
  // const dispatch = useDispatch();
  const { data: aboutData, isLoading: isAboutLoading } = useGetAboutQuery();
  const [editAboutMutation, { isLoading: isEditLoading }] = useEditAboutMutation();
  const error = useSelector((state) => state.error);
  // const getRoleRes = useSelector((state) => state.role.getRoleRes);

  const initialLinks = {
    heading: "",
    subHeading: "",
    banner: "",
    firstColHeading: "",
    firstColSubHeading: "",
    firstColDescription: "",
    secondColHeading: "",
    secondColSubHeading: "",
    secondColDescription: "",
  };

  const [links, setLinks] = useState(initialLinks);
  const [permissions, setPermissions] = useState({});
  const [msg, setMsg] = useState(initialLinks);

  const [award, setAward] = useState([]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  var CryptoJS = require("crypto-js");

  

  const roleEncrypted = localStorage.getItem("role");
  const roleDecrypted = roleEncrypted
    ? CryptoJS.AES.decrypt(roleEncrypted, ENV.secretKey).toString(
        CryptoJS.enc.Utf8
      )
    : "";
  const { data: roleData } = useGetRoleQuery(roleDecrypted, { skip: !roleEncrypted });

  useEffect(() => {
    if (roleData && roleData.role?.permissions) {
      if (typeof roleData.role.permissions === 'string') {
        setPermissions(JSON.parse(roleData.role.permissions));
      } else {
        setPermissions(roleData.role.permissions);
      }
    }
  }, [roleData]);

  useEffect(() => {
    if (aboutData) {
      const about = aboutData.about ?? aboutData;
      const award = aboutData.award ?? [];
      setLinks(about);
      setAward(award);
    }
  }, [aboutData]);

  

  const save = () => {
    let check = true;
    const newMsg = { ...msg };

    if (validator.isEmpty(links.metaDescription)) {
      newMsg.metaDescription = "Meta Description is required";
      check = false;
    }
    if (validator.isEmpty(links.metaKeyword)) {
      newMsg.metaKeyword = "Meta Keywords are Required";
      check = false;
    }
    if (validator.isEmpty(links.metaTitle)) {
      newMsg.metaTitle = "Meta Title is Required";
      check = false;
    }

    if (!check) {
      setMsg(newMsg);
      return;
    }

    if (check) {
      const formData = new FormData();
      for (const key in links) {
        formData.append(key, links[key]);
      }

      (async () => {
      await editAboutMutation(formData);
      setLinks(initialLinks);
    })();
    }
  };

  const onFileChange = (e) => {
    const file = e.target.files[0];
    const inputId = e.target.id;

    if (file) {
      const acceptedExtensions = [".jpg", ".jpeg", ".png"];
      const fileExtension = "." + file.name.split(".").pop().toLowerCase();

      if (!acceptedExtensions.includes(fileExtension)) {
        setMsg({
          ...msg,
          [inputId]:
            "Invalid file extension.\nValid file extensions are: jpg, jpeg, and png",
        });
        e.target.value = null;
        setLinks({ ...links, [inputId]: null });
      } else {
        setLinks({ ...links, [inputId]: file });
      }
    }
  };

  if (isAboutLoading || isEditLoading) {
    return <FullPageLoader />;
  }

  return (
    <>
      <Container fluid>
            <Row>
              <Col md="12">
                <Form
                  action=""
                  className="form-horizontal"
                  id="TypeValidation"
                  method=""
                >
                  <Card className="table-big-boy p-5">
                    <Card className="table-big-boy mb-5">
                      <Card.Header>
                        <div className="d-block d-md-flex align-items-center justify-content-between">
                          <Card.Title as="h4">About Page</Card.Title>
                        </div>
                      </Card.Header>

                      <Card.Body>
                        <Row>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Heading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.heading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    heading: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Sub Heading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.subHeading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    subHeading: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          {/* Banner */}
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Banner
                              </Form.Label>
                              <Form.Control
                                placeholder="banner"
                                type="file"
                                varient="info"
                                accept=".jpg,.jpeg,.png"
                                onChange={(e) => onFileChange(e)}
                                id="banner"
                              />
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                First Column Heading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.firstColHeading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    firstColHeading: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                First Column SubHeading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.firstColSubHeading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    firstColSubHeading: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                First Column Description
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.firstColDescription}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    firstColDescription: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Second Column Heading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.secondColHeading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    secondColHeading: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Second Column SubHeading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.secondColSubHeading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    secondColSubHeading: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Second Column Description
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.secondColDescription}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    secondColDescription: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>

                          {/* Repeat for other social inputs */}
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Mission/Vision Background Color
                              </Form.Label>
                              <Form.Control
                                type="color"
                                value={links.missionColor || "#FCEDC6"}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    missionColor: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Our Journey Background Color
                              </Form.Label>
                              <Form.Control
                                type="color"
                                value={links.journeyColor || "#ffffff"}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    journeyColor: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                    <hr className="centered-hr" />
                    <Card className="table-big-boy mb-5">
                      <Card.Header>
                        <div className="d-block d-md-flex align-items-center justify-content-between">
                          <Card.Title as="h4">
                            About Page Post Setting
                          </Card.Title>
                        </div>
                      </Card.Header>

                      <Card.Body>
                        <Row>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Post Heading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.postHeading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    postHeading: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Post SubHeading
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.postSubHeading}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    postSubHeading: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Post Description
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.postDescription}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    postDescription: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>

                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Post Url
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={links.postUrl}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    postUrl: e.target.value,
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Post Image
                              </Form.Label>
                              <Form.Control
                                placeholder="post image"
                                type="file"
                                varient="info"
                                accept=".jpg,.jpeg,.png"
                                onChange={(e) => onFileChange(e)}
                                id="postImage"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                    <hr className="centered-hr" />
                    <Card className="table-big-boy mb-5">
                      <Card.Header>
                        <div className="d-block d-md-flex align-items-center justify-content-between">
                          <Card.Title as="h4">Awards Setting</Card.Title>
                        </div>
                      </Card.Header>

                      <Card.Body>
                        <Row>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Show Awards
                              </Form.Label>

                              <div className="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  name="isAward"
                                  onChange={(e) =>
                                    setLinks({
                                      ...links,
                                      isAward: !links.isAward,
                                    })
                                  }
                                  checked={links?.isAward}
                                />
                                <span className="checkmark"></span>
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <hr className="centered-hr" />
                    <Card className="table-big-boy mb-5">
                      <Card.Header>
                        <div className="d-block d-md-flex align-items-center justify-content-between">
                          <Card.Title as="h4">SEO Settings</Card.Title>
                        </div>
                      </Card.Header>

                      <Card.Body>
                        <Row>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Meta Title
                              </Form.Label>
                              <Form.Control
                                className={msg.metaTitle ? `on-error` : ``}
                                type="text"
                                value={links.metaTitle}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    metaTitle: e.target.value,
                                  })
                                }
                              ></Form.Control>
                              <span className={msg.metaTitle ? `` : `d-none`}>
                                <label className="pl-1 pt-0 text-danger">
                                  {msg.metaTitle}
                                </label>
                              </span>
                            </Form.Group>
                          </Col>

                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Meta Keyword
                              </Form.Label>
                              <Form.Control
                                className={msg.metaKeyword ? `on-error` : ``}
                                type="text"
                                value={links.metaKeyword}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    metaKeyword: e.target.value,
                                  })
                                }
                              ></Form.Control>
                              <span className={msg.metaKeyword ? `` : `d-none`}>
                                <label className="pl-1 pt-0 text-danger">
                                  {msg.metaKeyword}
                                </label>
                              </span>
                            </Form.Group>
                          </Col>
                          <Col xl={4} md={6}>
                            <Form.Group>
                              <Form.Label className="d-block mb-2">
                                Meta Description
                              </Form.Label>
                              <Form.Control
                                className={
                                  msg.metaDescription ? `on-error` : ``
                                }
                                type="text"
                                value={links.metaDescription}
                                onChange={(e) =>
                                  setLinks({
                                    ...links,
                                    metaDescription: e.target.value,
                                  })
                                }
                              ></Form.Control>
                              <span
                                className={msg.metaDescription ? `` : `d-none`}
                              >
                                <label className="pl-1 pt-0 text-danger">
                                  {msg.metaDescription}
                                </label>
                              </span>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                    <hr className="centered-hr" />
                    <Card.Footer>
                      <Row className="float-right">
                        {permissions.editAbout && (
                          <Col sm={12} className="d-flex">
                            <Button className="btn-filled mt-3" onClick={save}>
                              Save
                            </Button>
                          </Col>
                        )}
                      </Row>
                    </Card.Footer>
                  </Card>
                </Form>
              </Col>
            </Row>
          </Container>
          {links.isAward && (
            <AwardForm
              oldAward={award}
              permissions={permissions}
            />
          )}
    </>
  );
};

export default About;
